// extracted by mini-css-extract-plugin
export var comment = "GoogleReviews-module--comment--5fd93";
export var content = "GoogleReviews-module--content--a4080";
export var image = "GoogleReviews-module--image--f0cfa";
export var review = "GoogleReviews-module--review--ce9b9";
export var reviewer = "GoogleReviews-module--reviewer--ffda9";
export var root = "GoogleReviews-module--root--80e41";
export var seeMore = "GoogleReviews-module--seeMore--e1612";
export var starsWrapper = "GoogleReviews-module--starsWrapper--c57e1";
export var swiper = "GoogleReviews-module--swiper--e3acd";
export var swiperSlide = "GoogleReviews-module--swiper-slide--e588d";
export var topSwirl = "GoogleReviews-module--topSwirl--08fb4";